import { useLayoutEffect, useState } from "react";

// 팝오버 배치 — scss .ds-dropdown-popover 의 top 4px·max-height 360 과 같은 값
export const POPOVER_GAP = 4;
export const POPOVER_MAX_HEIGHT = 360;
export const POPOVER_MIN_HEIGHT = 160; // 이보다 좁으면 반대쪽으로 연다
export const POPOVER_VIEWPORT_MARGIN = 16; // 화면 가장자리와의 최소 간격

/**
 * .ds-dropdown-popover 를 뷰포트에 맞추는 인라인 style (DSDropdown·DSTimeInput 공용).
 *
 * 트리거가 화면 아래쪽이면 기본 max-height(360)가 바닥에 닿아 마지막 항목을 고르기
 * 어렵다 — 아래 여유에 맞춰 max-height 를 줄이고, 그래도 모자라면 위로 연다.
 * 기준은 window 뷰포트라 overflow 스크롤 컨테이너 안에서는 컨테이너 기준으로 뒤집지 않는다.
 *
 * @param {boolean} open - 열린 동안만 계산. 닫히면 null
 * @param {React.RefObject<HTMLElement>} anchorRef - 팝오버 position 의 기준 요소(트리거를 감싼 wrapper)
 * @returns {React.CSSProperties|null} 팝오버 style 에 spread 할 값
 */
export default function usePopoverPlacement(open, anchorRef) {
  const [style, setStyle] = useState(null);

  useLayoutEffect(() => {
    if (!open || !anchorRef.current) {
      setStyle(null);
      return;
    }
    const rect = anchorRef.current.getBoundingClientRect();
    const below = window.innerHeight - rect.bottom - POPOVER_GAP - POPOVER_VIEWPORT_MARGIN;
    const above = rect.top - POPOVER_GAP - POPOVER_VIEWPORT_MARGIN;
    if (below >= POPOVER_MIN_HEIGHT || below >= above) {
      setStyle({ maxHeight: Math.max(POPOVER_MIN_HEIGHT, Math.min(POPOVER_MAX_HEIGHT, below)) });
      return;
    }
    setStyle({
      top: "auto",
      bottom: `calc(100% + ${POPOVER_GAP}px)`,
      maxHeight: Math.max(POPOVER_MIN_HEIGHT, Math.min(POPOVER_MAX_HEIGHT, above)),
    });
  }, [open, anchorRef]);

  return style;
}
